import styled from 'styled-components';
import WithDirection from "../../../../config/withDirection";

const StyleWrapper = styled.div`    
    .summary-title { margin-bottom: 24px; }
    .summary-title .ratings {
        display: flex;
        align-items: baseline;
        margin-top: 24px;
        font-size: 18px;
        font-weight: 700;
        color: #999;
        text-transform: none;
    }
    .summary-title .ratings > * { margin-right: 28px; }
    .summary-title .rating-icon { align-self: end; height: 100px; }
    .summary-title .ratings span {
        font-size: 70px;
        font-weight: 700;
        color: rgba(64, 55, 57, 1);
        letter-spacing: -0.5px;
    }

    .reviews {
        display: grid;
        grid-template-columns: 33% 33% 33%;
        grid-column-gap: 0.5%;
        margin-bottom: 24px;
    }
    .reviews .reviews-toggle {
        grid-column-start: 1;
        grid-column-end: 4;
        background-color: #efefef;
        font-size: 24px;
        text-align: center;
    }

    .grid-container {
        display: grid;
        grid-template-columns: 49.5% 49.5%;
        grid-column-gap: 1%;
        grid-row-gap: 3px;
    }

    .grid-content .recharts-wrapper {
        display: flex;
        justify-content: center;
        width: 100% !important;
        text-align: center;
    }
    .grid-content .recharts-wrapper svg {
        margin: 0 auto;
        margin-top: 28px;
    }
    .grid-content:last-child {
        grid-column-start: 1;
        grid-column-end: 3;
    }

    @media screen and (max-width: 480px) {
        .ratings { flex-wrap: wrap; justify-content: center; }
        .ratings img ~ * { margin: 0 7px !important; }
        .ratings img ~ :last-child { flex-grow: 1; text-align: center; }

        .reviews {
            grid-template-columns: 100%;
            grid-column-gap: 0;
            grid-row-gap: 4px;
            margin-bottom: 24px;
        }
        .reviews .review:last-child { display: none; }
        .reviews .reviews-toggle { display: none; }

        .grid-container { grid-template-columns: 100%; }
        
        .grid-container > *:nth-child(3) { grid-row: 2; }
        .grid-container > *:nth-child(5) { grid-row: 3; }
        .grid-content:last-child { grid-column-end: 2; }
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridRating/Wrapper.js